import { render, staticRenderFns } from "./updateTransfer.vue?vue&type=template&id=23aed35e&scoped=true&"
import script from "./updateTransfer.vue?vue&type=script&lang=ts&"
export * from "./updateTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./updateTransfer.vue?vue&type=style&index=0&id=23aed35e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aed35e",
  null
  
)

export default component.exports